import { number } from "prop-types";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";

export const TeamMembersTag = ({ teamMembers }) => {
  const classes = useStyle();

  if (!teamMembers || teamMembers === 1) return <></>;

  return (
    <Grid
      item
      container
      alignItems="center"
      justifyContent="center"
      className={classes.teamMembers}
    >
      {teamMembers}
    </Grid>
  );
};

TeamMembersTag.propTypes = {
  teamMembers: number,
};

const useStyle = makeStyles((theme) => ({
  teamMembers: {
    marginLeft: 8,
    fontSize: 10,
    fontWeight: 600,
    width: 16,
    height: 16,
    borderRadius: "50%",
    background: theme.props.warning,
    color: theme.props.text.alt,
  },
}));